var _defs, _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCopyLight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-2{fill:none}\n        "))), /*#__PURE__*/React.createElement("g", {
    id: "icon-copy-default2",
    transform: "translate(-888 -133)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    transform: "translate(888 133)",
    style: {
      stroke: "#0222ba",
      fill: "none"
    }
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 11,
    r: 11,
    style: {
      stroke: "none"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 11,
    cy: 11,
    r: 10.5
  }))), /*#__PURE__*/React.createElement("g", {
    id: "content_copy_black_24dp",
    transform: "translate(892.833 137.833)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_211",
    "data-name": "Path 211",
    className: "cls-2",
    d: "M0 0h12.334v12.334H0z"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_212",
    "data-name": "Path 212",
    d: "M9.1 1H3.014A1.022 1.022 0 0 0 2 2.023v7.162h1.014V2.023H9.1zm1.521 2.046H5.043a1.022 1.022 0 0 0-1.014 1.023v7.162a1.022 1.022 0 0 0 1.014 1.023h5.579a1.022 1.022 0 0 0 1.014-1.023V4.069a1.022 1.022 0 0 0-1.014-1.023zm0 8.185H5.043V4.069h5.579z",
    transform: "translate(-.921 -.46)",
    style: {
      fill: "#0222ba"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCopyLight);
export default __webpack_public_path__ + "static/media/icon-copy-light.ca95c28e1708efe0edd9b882cb4ac997.svg";
export { ForwardRef as ReactComponent };